module.exports = __webpack_public_path__ + "assets/img/icon-loading.e64f1db3.png";